import * as React from 'react';
import { BatchUploadStats, FileUploadItem } from './types';
import { getUploadProgressSummary, RateLimitReason } from './upload-utils';
import { useRateLimitCountdown } from './use-rate-limit-countdown';
import { UploadProgressItem } from './upload-progress-item';
import * as S from './upload-progress.styles';

export interface UploadProgressListProps {
    items: FileUploadItem[];
    stats: BatchUploadStats;
    isUploading: boolean;
    isPaused?: boolean;
    isRateLimited?: boolean;
    rateLimitResumeAt?: number;
    rateLimitReason?: RateLimitReason;
}

export const UploadProgressList: React.FC<UploadProgressListProps> = ({
    items,
    stats,
    isUploading,
    isPaused = false,
    isRateLimited = false,
    rateLimitResumeAt,
    rateLimitReason,
}) => {
    const rateLimitSecondsRemaining = useRateLimitCountdown(isRateLimited, rateLimitResumeAt);
    const { title, subtitle } = getUploadProgressSummary(stats, isUploading, isPaused, {
        isRateLimited,
        rateLimitSecondsRemaining,
        rateLimitReason,
    });

    return (
        <S.ListContainer>
            <S.ListHeader>
                <S.ListTitle>{title}</S.ListTitle>
                {subtitle && <S.ListSubtitle>{subtitle}</S.ListSubtitle>}
            </S.ListHeader>

            <S.ItemList>
                {items.map(item => (
                    <UploadProgressItem key={item.id} item={item} />
                ))}
            </S.ItemList>
        </S.ListContainer>
    );
};
